import { pluginFactory } from './utils/plugins';

//
const BVConfigPlugin = /*#__PURE__*/pluginFactory();

export { BVConfigPlugin };
